import Vue from 'vue'
import store from '@/store/index.js'

import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'

import awsconfig from './aws-exports'
import _ from "lodash"


awsconfig.API.endpoints.forEach((endpoint => {
    endpoint.custom_header = async () => {
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer ${(await AmplifyModules.Auth.currentSession()).getIdToken().getJwtToken()}`
        }
    }
}))

Amplify.configure(awsconfig)

AmplifyModules.API.configure(awsconfig);
AmplifyModules.Storage.configure(awsconfig);

let API_NAME = process.env.VUE_APP_APIName;

const storageSettings = {
    level: "public",
    track: true,
    customPrefix: {
        public: 'resources/',
        protected: 'resources/',
        private: 'resources/'
    }
}

Vue.prototype.$Storage = {
    get: async (path, customSettings) => {
        store.dispatch("initLoader");
        //** console.log(`Downloading [${path}]`)

        let settings = _.merge({
            // headers: HEADERS(),
            download: false
        }, storageSettings);

        if (customSettings) {
            settings = _.merge({
                settings,
                customSettings
            })
        }

        return AmplifyModules.Storage.get(path, settings)
            .then((url) => {
                //** console.log(url)
                return url;
            })
            .catch((e) => {
                //** console.log(e)
                throw e
            })
            .finally(() => {
                store.dispatch("stopLoader");
            });
    },

    put: async (path, data, progressCallback, completionCallback) => {
        store.dispatch("initLoader");

        let settings = _.merge({
            progressCallback(progress) {

                if (progressCallback) {
                    progressCallback(progress);
                }
                if (progress.loaded === progress.total && completionCallback) {
                    completionCallback(path, data);
                    store.dispatch("stopLoader");
                }
            }
        }, storageSettings);

        console.log("S3 config")
        console.log(awsconfig)
        console.log("S3 Configure")
        console.log(AmplifyModules.Storage.configure())
        console.log("PATH:" + path)

        AmplifyModules.Storage.put(path, data, settings);
    }
}



//
Vue.prototype.$GET = async (url, params) => {
    store.dispatch("initLoader");
    if (params) {
        Object.keys(params).forEach(key => {
            let pattern = RegExp(`{{${key}}}`, "g")
            url = url.replace(pattern, params[key])
        })
    }
    return AmplifyModules.API.get(API_NAME, url ) //, HEADERS())
        .then(response => {
            return response;
        })
        .finally(() => store.dispatch("stopLoader"));
};

Vue.prototype.$POST = async (url, payload) => {
    store.dispatch("initLoader");
    if (payload && payload.params) {
        Object.keys(payload.params).forEach(key => {
            let pattern = RegExp(`{{${key}}}`, "g")
            url = url.replace(pattern, payload.params[key])
        })
    }

    let data = payload && payload.data ? payload.data : {}
    return AmplifyModules.API.post(API_NAME, url, {
        // headers: HEADERS(),
        body: data
    })
        .then(response => {
            return response;
        })
        .finally(() => store.dispatch("stopLoader"));
};

Vue.prototype.$PUT = async (url, payload) => {
    store.dispatch("initLoader");
    if (payload && payload.params) {
        Object.keys(payload.params).forEach(key => {
            let pattern = RegExp(`{{${key}}}`, "g")
            url = url.replace(pattern, payload.params[key])
        })
    }

    let data = payload && payload.data ? payload.data : {}
    return AmplifyModules.API.put(API_NAME, url, {
        // headers: HEADERS(),
        body: data
    })
        .then(response => {
            return response;
        })
        .finally(() => store.dispatch("stopLoader"));
};

Vue.prototype.$DELETE = async (url, payload) => {
    store.dispatch("initLoader");
    if (payload && payload.params) {
        Object.keys(payload.params).forEach(key => {
            let pattern = RegExp(`{{${key}}}`, "g")
            url = url.replace(pattern, payload.params[key])
        })
    }

    let data = payload && payload.data ? payload.data : {}
    return AmplifyModules.API.del(API_NAME, url, {
        // headers: HEADERS(),
        body: data
    })
        .then(response => {
            return response;
        })
        .finally(() => store.dispatch("stopLoader"));
};

Vue.use(AmplifyPlugin, AmplifyModules);

export default {}